import { useEffect, useState } from 'react';
import getVideoData from 'services/wistiaVideoService';

const useThumbnail = (thumbnail, url) => {
  const [videoThumbnail, setVideoThumbnail] = useState(null);

  useEffect(() => {
    if (thumbnail) {
      setVideoThumbnail({ image: thumbnail, url: thumbnail?.file?.url, type: 'contentful' });
    } else {
      (async () => {
        const formattedUrl = url?.trim();

        if (formattedUrl) {
          const data = await getVideoData(formattedUrl);

          if (data) {
            setVideoThumbnail({ url: data.thumbnail_url, type: 'wistia' });
          }
        }
      })();
    }
  }, [thumbnail]);

  return videoThumbnail;
};

export default useThumbnail;
